import { Form, FormInstance, InputNumber, Select } from 'antd'
import TimePicker from '../visits/TimePicker'
import { useUnbillableCategories } from '../../domain/unbillableCategories/unbillableCategoryQueries'
import { useEffect } from 'react'
import dayjs from 'dayjs'
import { UnbillableTimeWithBreakDeduction } from '../../domain/timeTracking/timeTrackingPeriod'

export type FormValues = Pick<UnbillableTimeWithBreakDeduction, 'startUtc' | 'endUtc' | 'unbillableCategoryId' | 'lunch'>

type Props = {
  form: FormInstance
  timeZone: string
}
const UnbillableForm = ({ form, timeZone }: Props) => {
  const unbillableCategories = useUnbillableCategories()

  const startUtc = Form.useWatch<string>('startUtc', form)
  const endUtc = Form.useWatch<string | undefined>('endUtc', form)
  const lunchMinutes = Form.useWatch<number | undefined>('lunch', form)
  const maxLunchMinutes = dayjs(endUtc).diff(dayjs(startUtc), 'minutes')
  useEffect(() => {
    if (lunchMinutes && lunchMinutes > maxLunchMinutes) {
      form.setFieldsValue({
        lunch: maxLunchMinutes,
      })
    }
  }, [maxLunchMinutes])

  return <>
    <div style={{ display: 'flex', gap: 16 }}>
      <Form.Item label="Start" name="startUtc" rules={[{ required: true, message: 'Start is required' }]}>
        <TimePicker onChange={() => { }} timeZone={timeZone} />
      </Form.Item>
      <Form.Item label="End" name="endUtc" rules={[{ required: true, message: 'End is required' }]}>
        <TimePicker onChange={() => { }} timeZone={timeZone} />
      </Form.Item>
      <Form.Item label="Lunch" name="lunch">
        <InputNumber min={0} addonAfter="min" max={maxLunchMinutes} />
      </Form.Item>
    </div>
    <Form.Item label="Category" name="unbillableCategoryId" rules={[{ required: true, message: 'Category is required' }]}>
      <Select options={unbillableCategories.data?.map(x => ({ label: x.name, value: x.id })) ?? []} popupMatchSelectWidth={false} />
    </Form.Item>
  </>
}

export default UnbillableForm